// File: src/components/SideNav.js

import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

import {
  FaPills,
  FaSignOutAlt,
  FaThLarge,
  FaBoxes,
  FaChartBar,
  FaCog,
  FaCashRegister
} from "react-icons/fa";

import "./SideNav.css";

const SideNav = ({ activePage }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    toast.success("Logged out successfully!");
    navigate("/");
  };

  const navItems = [
    { name: "POS", icon: <FaThLarge />, path: "/dashboard" },
    { name: "Sales", icon: <FaCashRegister />, path: "/sales" },
    { name: "Products", icon: <FaBoxes />, path: "/products" },
    { name: "Reports", icon: <FaChartBar />, path: "/reports" },
    { name: "Settings", icon: <FaCog />, path: "/settings" }
  ];

  return (
    <nav className="side-nav">

      {/* Logo */}
      <div className="side-nav-logo">
        <FaPills size={26} />
        <span>PharmaPOS</span>
      </div>

      {/* Navigation */}
      <ul className="side-nav-list">
        {navItems.map((item) => (
          <li key={item.name}>
            <button
              className={`nav-link ${activePage === item.name ? "active" : ""}`}
              onClick={() => navigate(item.path)}
            >
              <span className="icon">{item.icon}</span>
              <span className="text">{item.name}</span>
            </button>
          </li>
        ))}
      </ul>

      {/* Footer */}
      <div className="side-nav-footer">
        <button onClick={handleLogout} className="nav-link logout">
          <span className="icon"><FaSignOutAlt /></span>
          <span className="text">Logout</span>
        </button>
      </div>

    </nav>
  );
};

export default SideNav;